import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface TrackingRequest {
    chk_bl_no: string;
}

export interface TrackingResponse {
    B_L번호: string;
    addBlCnt: null;
    s_bl_no: string;
    담당자명: string;
    받는담당자: string;
    받는상호: string;
    받는전화번호: string;
    받는주소1: string;
    받는주소2: string;
    받는핸드폰번호: string;
    보내는담당자: string;
    보내는상호: string;
    보내는전화번호: string;
    보내는주소1: string;
    보내는주소2: string;
    보내는핸드폰번호: string;
    센터명: string;
    센터코드: string;
    수량: string;
    요청사항: string;
    운송장번호: string;
    운임: string;
    접수일자: string;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePostTrackingPopPrintView = (
    successCallback?: (data: TrackingResponse) => void,
): UseMutationResult<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest> => {
    const accessToken = useMorningAuthStore(state => state.accessToken);

    return useMutation<TrackingResponse, AxiosError<ApiErrorResponse>, TrackingRequest>({
        mutationFn: async requestData => {
            const payload = {
                chk_bl_no: requestData.chk_bl_no,
            };

            const url = enum_api_uri.tracking_pop_print_view;

            const response = await axios.post(url, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data.data;
        },

        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
